export const statsBaseURL = 'https://scorealarm-stats.global.ssl.fastly.net';

// Unused for now, might have to use them if we upgrade our Player
// export const performOutletKey = '1f4jp8n8pn2rh1fci56heuyczr';
// export const performRefererUrl = 'https://wab-visualisation.performgroup.com/csb/index.html';
// export const performParams = {
//     _rt: 'c',
//     _fmt: 'json',
//     _fld: 'sl,aLng,pa,pCfg,sTok',
//     aLng: 'en-gb,xx-xx',
// };
